import { Slide, Fade } from 'react-awesome-reveal';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DiariImage from 'assets/images/home/mockup-bulleti.png';
import MesJuntsLabel from './MesJuntsLabel';

function BannerButlleti() {
  return (
    <div className="flex justify-center items-center bg-gris-color p-6 gap-6 flex-col md:flex-row">
      <Fade triggerOnce delay={200}>
        <div className="flex flex-col items-center md:items-start gap-4">
          <MesJuntsLabel />
          <div className="flex gap-4 md:gap-2 items-center flex-col md:flex-row">
            <h2 className="text-2xl text-center md:text-left">
              <span className="font-bold">El butlletí </span> de l&apos;actualitat política que més
              t&apos;interessa
            </h2>
            <div className="inline-flex border border-solid border-second-color rounded-full text-second-color">
              <ArrowForwardIcon />
            </div>
          </div>
        </div>
        <Slide direction="right" triggerOnce duration={2000}>
          <img src={DiariImage} alt="Imatge d'un diari" width={600} />
        </Slide>
      </Fade>
    </div>
  );
}

export default BannerButlleti;
